import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminForgotPasswordService } from '../services/admin-forgot-password.service';
import { SETTINGS } from '../../../core/config/common.settings';
import { AppUtils } from '../../../core/config/app.utils';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
  forgotPasswordResponse: any = {};
  changePwdForm: any;
  formErrors: any;
  validating = true;
  userToken: any;
  confirmPasswordVisible = true;
  newPasswordVisible = true;

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private adminForgotPwdService: AdminForgotPasswordService,
    private router: Router
  ) {
    this.formErrors = {
      password: {},
      confirmPassword: {},
    };
  }

  ngOnInit(): void {
    this.changePwdForm = this.fb.group({
      password: [
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern(SETTINGS.REGEX.PASSWORD.EXP),
        ]),
      ],
      confirmPassword: [null, [this.confirmationValidator]],
    });

    this.changePwdForm.valueChanges.subscribe(() => {
      AppUtils.getFormErrors(this.changePwdForm, this.formErrors);
    });

    this.userToken = this.route.snapshot.paramMap.get('token');
    this.validateToken().then();
  }

  confirmationValidator = (control: FormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { required: true };
    } else if (control.value !== this.changePwdForm.controls.password.value) {
      return { confirm: true, error: true };
    }
    return {};
  };

  change(): void {
    const formData = this.changePwdForm.getRawValue();
    const payload = {
      token: this.forgotPasswordResponse.data.token,
      password: formData.password,
    };
    this.adminForgotPwdService
      .resetPassword({ link: `${location.origin}/auth/login`, payload })
      .then(() => {
        this.router.navigate(['/auth/login']);
      });
  }

  async validateToken(): Promise<any> {
    this.forgotPasswordResponse =
      await this.adminForgotPwdService.validatePWResetToken(this.userToken);
    this.validating = false;
  }
}
